import { logEvent, setUserId, setUserProperties } from "firebase/analytics";
import { analytics } from "./firebaseConfig";

export const trackEvent = (
  eventName: string,
  params?: Record<string, unknown>,
) => {
  if (analytics) {
    logEvent(analytics, eventName, params);
  }
};

export const identifyUser = (
  userId: string,
  properties?: Record<string, unknown>,
) => {
  if (analytics) {
    setUserId(analytics, userId);
    if (properties) {
      setUserProperties(analytics, properties);
    }
  }
};
